import { useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";

const fmt = (d) => d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

// Pincode "instant delivery" check, shown on the account page for every
// customer — plus the founding-member free-delivery status on top of it when
// applicable. No upsell pitch here for non-members; that offer already lives
// in the welcome popup / checkout, this card is purely a delivery-status tool.
export default function MembershipCard() {
  const { membership } = useAuth();
  const [pin, setPin] = useState("");
  const [pinStatus, setPinStatus] = useState(null); // null | "ok" | "bad"

  const checkPin = (e) => {
    e.preventDefault();
    setPinStatus(/^\d{6}$/.test(pin) ? "ok" : "bad");
  };

  return (
    <div className={`member-card ${membership?.active ? "member-card--active" : ""}`}>
      {membership?.active && (
        <div className="member-card__head">
          <span className="member-card__badge">🎉 Founding member</span>
          <p>
            Free delivery on every order until{" "}
            <strong>{fmt(membership.expiresAt)}</strong>.
          </p>
        </div>
      )}
      {!membership?.active && membership?.since && (
        <p className="member-card__lapsed">
          Your founding-member free delivery ended on {fmt(membership.expiresAt)}.
        </p>
      )}

      <form className="member-card__pin" onSubmit={checkPin}>
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="Enter your pincode"
          value={pin}
          onChange={(e) => {
            setPin(e.target.value.replace(/\D/g, ""));
            setPinStatus(null);
          }}
          aria-label="Delivery pincode"
        />
        <button type="submit">Check instant delivery</button>
      </form>
      {pinStatus === "ok" && (
        <p className="member-card__pin-msg member-card__pin-msg--ok" role="status">
          ✓ Instant delivery available to {pin}
          {membership?.active ? " — free, as a founding member." : "."}
        </p>
      )}
      {pinStatus === "bad" && (
        <p className="member-card__pin-msg member-card__pin-msg--bad" role="alert">
          Please enter a valid 6-digit pincode.
        </p>
      )}
    </div>
  );
}
